<template>
  <div class="contract-manage-contain">
    <section class="contract-search-filter clearfix">
      <div class="search-bar-lf">
        <el-form
          label-position="top"
          :inline="true"
          :model="dataForm"
          width="100%"
          class="search-bar-form"
        >
          <!-- 供应商组织编号 -->
          <el-form-item :label="$t('contract.supplierCode')" class="search-bar-module">
            <el-input
              v-model="dataForm.supplierCode"
              :placeholder="$t('contract.inputTips')"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 供应商名称 -->
          <el-form-item :label="$t('contract.supplierName')" class="search-bar-module">
            <el-input
              v-model="dataForm.supplierNameCn"
              :placeholder="$t('contract.inputTips')"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 合同类型 -->
          <el-form-item :label="$t('contract.type')" class="search-bar-module">
            <el-select v-model="dataForm.type" clearable>
              <el-option
                v-for="item in typeList"
                :key="'type'+item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 合同状态 -->
          <el-form-item :label="$t('contract.status')" class="search-bar-module">
            <el-select v-model="dataForm.status" clearable>
              <el-option
                v-for="(item,index) in statusList"
                :key="'status'+index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 合同编号 -->
          <el-form-item :label="$t('contract.id')" class="search-bar-module">
            <el-input
              v-model="dataForm.contractNo"
              :placeholder="$t('contract.inputTips')"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 合同所属团队 -->
          <el-form-item
            :label="$t('contract.team')"
            class="search-bar-module search-bar-module2"
          >
            <el-select v-model="dataForm.ownOrgId" clearable>
              <el-option
                v-for="item in teamList"
                :key="'team'+item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="search-bar-lr">
        <el-button class="M-search button-margin-b" type="primary" @click="searchList">
          {{ $t("query") }}
        </el-button>
        <el-button class="M-search el-back M-margin-l" type="info" @click="resetList">
          {{ $t("reset") }}
        </el-button>
      </div>
    </section>
    <div class="contract-content">
      <section class="contract-toolbar">
        <el-button class="popup-manage-add" type="primary" @click="addContract">
          {{ $t("add") }}
        </el-button>
        <el-tooltip placement="top-start" effect="light">
          <div slot="content">{{ $t("couse.exportMsg") }}</div>
          <el-button class="popup-manage-add" type="primary" @click="downloadContract">
            {{ $t("contract.export") }}
            <em class="el-icon-question"></em>
          </el-button>
        </el-tooltip>
      </section>
      <section class="contract-list">
        <el-table v-loading="dataListLoading"
          :data="dataList"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            header-align="center"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column
            type="index"
            :label="$t('pop.no')"
            :index="initIndex"
            width="70"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            header-align="center"
            align="center"
            :width="item.width"
            :show-overflow-tooltip="true"
            v-for="(item, index) in columnList"
            :key="'pop-list' + index"
          >
          </el-table-column>
          <!-- 操作 -->
          <el-table-column fixed="right" align="center" width="140" :label="$t('handle')">
            <template slot-scope="scope">
              <span class="contract-manage-operate" @click="viewContract(scope.row)">{{  $t("view") }}</span>
              <span class="contract-manage-operate-line"></span>
              <el-dropdown trigger="click" placement="bottom">
                <span class="el-dropdown-link">
                  {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="editContract(scope.row)">{{ $t("update") }}</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.status === 1"
                    @click.native="activityContract(scope.row, 0)">{{ $t('res.noActivity') }}</el-dropdown-item>
                  <el-dropdown-item v-else 
                  @click.native="activityContract(scope.row, 1)">{{ $t("res.activity") }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="contract-manage-footer">
        <el-pagination
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
        >
        </el-pagination>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dataForm: {
        supplierCode: '',
        supplierNameCn: '',
        contractNo: '',
        type: '',
        status: '',
        ownOrgId: ''
      },
      dataForms: {
        supplierCode: '',
        supplierNameCn: '',
        contractNo: '',
        type: '',
        status: '',
        ownOrgId: ''
      },
      typeList: this.enums['contractType'],
      teamList: this.enums['contractOwnOrg'],
      statusList: [
        { label: this.$t('res.noActivity'), value: '0' },
        { label: this.$t('res.activity'), value: '1' },
      ],
      dataListLoading: false,
      dataList: [],
      columnList: [
        { label: this.$t('contract.id'), prop: 'contractNo' },
        { label: this.$t('contract.orgNumber'), prop: 'supplierCode', width: 120 },
        { label: this.$t('contract.supplierNameCn'), prop: 'supplierNameCn', width: 140 },
        { label: this.$t('contract.timeStartEnd'), prop: 'contractTime', width: 200 },
        { label: this.$t('contract.type'), prop: 'typeName' },
        { label: this.$t('contract.status'), prop: 'statusName', width: 100 },
        { label: this.$t('contract.teamName'), prop: 'ownOrgName', width: 100 },
        { label: this.$t('contract.createTime'), prop: 'createTime' },
        { label: this.$t('contract.updateTime'), prop: 'updateTime' }
      ],
      multipleSelection: []
    };
  },
  methods: {
    initIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    pageSizeChangeHandle(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.getDataList();
    },
    pageCurrentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    searchList () {
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDataList();
    },
    // 获取合同列表
    getDataList () {
      const { supplierCode,supplierNameCn,type, status, contractNo, ownOrgId  } = this.dataForm;
      this.dataForms = JSON.parse(JSON.stringify(this.dataForm));
      const params = {
        contractBase: {
          supplierCode,
          supplierNameCn,
          type,
          status,
          contractNo,
          ownOrgId
        },
        paginationSettings: {
          pageNo: this.pageNum,
          pageSize:this.pageSize
        }
      };
      this.dataListLoading = true;
      this.$request.post('/learning/contract/queryPagedList', params).then((res) => {
        if (res) {
          this.dataListLoading = false;
          this.total = res.total;
          this.dataList = res.records || [];
        }
      }).catch(() => {
        this.dataListLoading = false;
      });
    },
    resetList () {
      Object.keys(this.dataForm).forEach((item) => {
        this.dataForm[item] = item === 'status' ? null : '';
      });
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDataList();
    },
    // 添加合同
    addContract () {
      this.$router.push({
        name: 'rm-contract-contractEdit',
        query: {
          edit: 1,
        },
      });
      this.$eventHub.$emit('contractManageEdit', '');
    },
    // 查看详情
    viewContract (val) {
      this.$router.push({
        name: 'rm-contract-contractDetail',
        query: {
          contractNo: val.contractNo,
        },
      });
      this.$eventHub.$emit('contractManageDetail', '');
    },
    editContract (val) {
      this.$router.push({
        name: 'rm-contract-contractEdit',
        query: {
          edit: 0,
          contractNo: val.contractNo,
          id: val.id
        },
      });
      this.$eventHub.$emit('contractManageEdit', '');
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    // 修改状态
    activityContract (val, status) {
      const params = {
        id: val.id,
        type: val.type,
        status
      };
      if (val.inEffect) {
        this.$message({
          message: this.$t('contract.nowActiveContract3'),
          type: 'warning',
        });
      } else {
        this.$request.post('/learning/contract/updateContract', params).then(() => {
          this.$message({
            message: this.$t('contract.statusUpdate'),
            type: 'success'
          });
          this.searchList();
        });
      }
    },
    formDateTime(val) {
      const date = new Date(val * 1);
      const year = date.getFullYear();
      const month = date.getMonth() < 9 ? `0${  date.getMonth() + 1}` : date.getMonth() + 1;
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return `${year}-${month}-${day} ${hour}:${minute}:${seconds}`;
    },
    // 导出合同
    downloadContract () {
      const arr = this.multipleSelection.map((item) => {
        return item.id;
      });
      let params = {
        id: arr.toString()
      };
      if (arr.length === 0) {
         const { supplierCode,supplierNameCn,type, status, contractNo, ownOrgId  } = this.dataForms;
         params = {
          supplierCode,
          supplierNameCn,
          type,
          status,
          contractNo,
          ownOrgId
        };
      }
      this.$request.downloadByPost7(
        '/learning/contract/exportContract',
        `合同下载${  this.formDateTime(new Date())  }.xls`,
        params, null, 'xls'
      );
    }
  },
  mounted() {
    this.searchList();
    this.$eventHub.$on('contractManage', (data) => {
      if (data) {
        Object.keys(this.dataForm).forEach((item) => {
          this.dataForm[item] = item === 'status' ? null : '';
        });
        this.pageSize = 10;
        this.pageNum = 1;
        this.searchList();
      }
    });
  },
};
</script>
<style lang="scss">
.contract-manage-contain {
  min-height: calc(100% - 120px);
  .contract-search-filter {
    height: 100%;
    width: 100%;
    display: flex;
    background-color: #ffffff;
    padding: 15px;
    margin-bottom: 12px;
    .search-bar-lf {
      flex: 8;
      display: flex;
      flex-direction: row;
      .search-bar-form {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .search-bar-module {
          flex: 0 0 32%;
          padding-right: 5%;
          .el-date-editor {
            width: 100% !important;
          }
        }
      }
    }
    .search-bar-lr {
      flex: 1;
      vertical-align: middle;
      padding-top: 10px;
      .button-margin-b {
        margin-bottom: 7px;
      }
    }
  }
  .contract-content {
    background-color: #ffffff;
    padding: 15px;
    .contract-toolbar {
      height: 34px;
      margin-bottom: 12px;
      .popup-manage-add {
        width: 80px;
      }
    }
    .contract-manage-operate {
      cursor: pointer;
      color: #409eff;
      &:hover {
        opacity: .8;
      }
    }
    .contract-manage-operate-line {
      display: inline-block;
      width: 1px;
      height: 20px;
      margin: 0 8px;
      vertical-align: middle;
      position: relative;
      background-color: #DCDFE6;
    }
  }
}
</style>